import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit {

  @Input() width: string = "250px";
  @Input() height: string = "250px";
  @Input() src: string = "https://www.youtube.com/embed/CD-E-LDc384";

  constructor() { }

  ngOnInit(): void {
  }

}
